import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import classNames from "classnames";
import i18next from "i18next";
import General from "./General";

const WalletPage = observer(() => {
  const [activeTab, setActiveTab] = useState("platform");
  return (
    <div className="page-wallet flex flex-col gap-4 text-white p-4">
      <h2 className="text-xl font-bold text-white">{i18next.t("my_assets")}</h2>
      <General />
    </div>
  );
});

export default WalletPage;
